import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetImportHistoryResponse } from '@/api/handlers/resources/purchases/responses';
import { PURCHASES_LIST_PAGE_SIZE } from '@/api/handlers/resources/purchases/queries';
import type { ApiResponse } from '@/api/handlers/responses';
import { PurchaseQueryKeys } from './purchaseQueryKeys';

export const useImportHistoryQuery = (
    pageSize = PURCHASES_LIST_PAGE_SIZE,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetImportHistoryResponse>>({
        queryKey: PurchaseQueryKeys.importHistory(pageSize),
        queryFn: () => apiClient.purchases.getImportHistory({ pageSize }),
        enabled,
        staleTime: 60_000,
    });
};
